import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Heart, HeartFill } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { useAuth } from "../context/authContext";
import Loader from './loader';
const API  = process.env.REACT_APP_API_URL;
const Categoryproducts = () => {
    const { category } = useParams(); // e.g., "antibiotics", "skincare"
    const navigate = useNavigate();
     const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    const { wishlist, handleAddToWishlist, handleRemoveFromWishlist,products,fetchProducts } = useAuth();

    // Format category name for display
    const categoryName = category
        ? category.charAt(0).toUpperCase() + category.slice(1).replace(/-/g, ' ')
        : 'Products';

    useEffect(() => {
         fetchProducts();
      

                // Filter by category
                if (products && products.length > 0) {
                const filtered = category && category !== 'all'
                    ? products.filter(product => product.category?.toLowerCase() === category.toLowerCase())
                    : products;
                    setFilteredProducts(filtered);
                    setLoading(false);

                }
       

       
    }, [category]);

    const handleCardClick = (id) => navigate(`/product/${id}`);

    const handleWishlistToggle = async (e, product_id) => {
        e.stopPropagation();
        const token = localStorage.getItem('token');
        if (!token) {
            toast.info('Please login to add to wishlist');
            return;
        }

const isInWishlist = wishlist.some(item => item.product_id === product_id);
        try {
            if (isInWishlist) {
                await handleRemoveFromWishlist(product_id);
                toast.success('Removed from wishlist');
            } else {
                await handleAddToWishlist(product_id);
                toast.success('Added to wishlist!');
            }
        } catch (err) {
            toast.error('Failed to update wishlist');
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-2xl font-bold text-red-600">Loading {categoryName}...</div>
            </div>
        );
    }

    if (products.length === 0) {
        return (
            <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center py-20">
                <h2 className="text-4xl font-bold text-gray-700 mb-4">
                    No products found in <span className="text-red-600">{categoryName}</span>
                </h2>
                <button
                    onClick={() => navigate('/')}
                    className="mt-6 px-10 py-4 bg-gradient-to-r from-red-600 to-red-700 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-800 transition shadow-lg"
                >
                    Back to All Products
                </button>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 pt-10 pb-20">
            {/* Category Header */}
            <div className="text-center mb-12">
                <h1 className="text-4xl font-black text-gray-800">
                    {categoryName}
                </h1>
                <p className="text-xl text-gray-600 mt-3">
                    {filteredProducts.length} product{filteredProducts.length > 1 ? 's' : ''} available
                </p>
            </div>

            {/* Products Grid - Responsive & Beautiful */}
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                    {filteredProducts.map(product => {
const isInWishlist = wishlist.some(item => item.product_id === product.product_id);
                        return (
                            <div
                                key={product.product_id}
                                onClick={() => handleCardClick(product.product_id)}
                                className="group cursor-pointer"
                            >
                                <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden">
                                    {/* Image Container */}
                                    <div className="relative bg-gray-100 pt-[100%] overflow-hidden">
                                        <img
                                            src={`${API}${product.image}`}
                                            alt={product.name}
                                            className="absolute inset-0 w-full h-full object-contain p-6 group-hover:scale-110 transition-transform duration-500"
                                        />

                                        {/* Wishlist Heart */}
                                        <div
                                            onClick={(e) => handleWishlistToggle(e, product.product_id)}
                                            className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-lg hover:scale-110 transition"
                                        >
                                            {isInWishlist ? (
                                                <HeartFill className="text-red-500 text-xl" />
                                            ) : (
                                                <Heart className="text-gray-600 text-xl hover:text-red-500 transition" />
                                            )}
                                        </div>
                                    </div>

                                    {/* Product Info */}
                                    <div className="p-4 text-center">
                                        <h3 className="font-bold text-gray-800 text-sm line-clamp-2 leading-tight">
                                            {product.name}
                                        </h3>
                                        <p className="text-gray-500 text-xs mt-1 line-clamp-2">
                                            {product.smalldescription}
                                        </p>

                                        <div className="flex justify-center items-center gap-2 mt-3">
                                            <span className="bg-green-600 text-white text-xs font-bold px-2 py-1 rounded">
                                                {product.rating} ★
                                            </span>
                                            <span className="text-gray-500 text-xs">({product.reviews || 0})</span>
                                        </div>

                                        <p className="text-red-600 font-bold text-lg mt-3">
                                            ₹{product.price}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Categoryproducts;